import { createRouter, createWebHistory } from 'vue-router'
import HelloWorld from '../components/HelloWorld.vue'
import CourseCenter from '../views/CourseCenter.vue'
import PersonalCenter from '../views/PersonalCenter.vue'
import MemberService from '../views/MemberService.vue'
import Register from '../views/Register.vue'
import ForgotPassword from '../views/ForgotPassword.vue'
import CourseMore from '../views/CourseMore.vue'
import CourseDetail from '../views/CourseDetail.vue'
import WechatCallback from '../views/WechatCallback.vue'
import BindPhone from '../views/BindPhone.vue'
import StaticPage from '../views/StaticPage.vue'
import eventBus from '@/utils/eventBus'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HelloWorld
  },
  {
    path: '/callback',
    name: 'WechatCallback',
    component: WechatCallback
  },
  {
    path: '/bind-phone',
    name: 'BindPhone',
    component: BindPhone
  },
  {
    path: '/course-detail/:id',
    name: 'CourseDetail',
    component: CourseDetail
  },
  {
    path: '/course-more',
    name: 'CourseMore',
    component: CourseMore
  },
  {
    path: '/course',
    name: 'CourseCenter',
    component: CourseCenter
  },
  {
    path: '/personal',
    name: 'PersonalCenter',
    component: PersonalCenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/member',
    name: 'MemberService',
    component: MemberService,
    meta: { requiresAuth: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword
  },
  {
    path: '/agreement',
    name: 'Agreement',
    component: StaticPage
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: StaticPage
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 处理微信扫码登录回调：如果访问根路径且带有 code 和 state 参数，重定向到 /callback
  if (to.path === '/' && to.query.code && to.query.state) {
    return next({
      path: '/callback',
      query: to.query,
      replace: true
    })
  }

  if (to.meta && to.meta.requiresAuth) {
    const token = localStorage.getItem('token')
    if (!token) {
      // 通过 eventBus 通知 HeaderMenu 打开登录弹窗
      if (eventBus && eventBus.emit) {
        eventBus.emit('show-login')
      }
      // 阻止进入受保护页面，回到首页
      return next({ path: '/', replace: true })
    }
  }
  next()
})

export default router
